let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4lWB4")).then(() => parcelRequire('ae24m'));